import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgDirectionalArrowRight = (props) => {
    const { color } = props;
    return (React.createElement("path", { fill: color, fillRule: "evenodd", d: "M10.769 19.682a1 1 0 0 1 .049-1.413L16.463 13H5a1 1 0 1 1 0-2h11.463l-5.645-5.269a1 1 0 1 1 1.364-1.462l7.5 7a1 1 0 0 1 0 1.462l-7.5 7a1 1 0 0 1-1.413-.049Z", clipRule: "evenodd" }));
};
export default factorySvgIcon(SvgDirectionalArrowRight);
//# sourceMappingURL=SvgDirectionalArrowRight.js.map